import { createFileRoute } from "@tanstack/react-router";
import { InboxBody } from "@/app/surfaces/inbox/inbox-body";
import {
  InboxHeader,
  InboxKindRail,
  InboxList,
  InboxMarkAllRead,
  InboxRows,
  InboxSearch,
  InboxToolbar,
  InboxUnreadToggle,
} from "@/app/surfaces/inbox/inbox-list";
import { InboxUrlProvider } from "@/app/surfaces/inbox/inbox-url-provider";

/**
 * The notification inbox (R1): a two-pane face over the sidecar's rows — list of
 * items on the left, the FACT IN CONTEXT on the right. The app shell already
 * supplies the icon rail, so this is the "secondary sidebar + content" half of
 * the shadcn `sidebar-09` shape.
 *
 * The route's only jobs are validating search params and COMPOSING the surface.
 * State and behaviour live in `InboxUrlProvider`; each control reads it from
 * context, so this tree says what the inbox is made of without wiring it.
 */
export const Route = createFileRoute("/inbox")({
  component: InboxComponent,
  // `unread` is a string, not a boolean: every route's search type unions into
  // the app-wide `location.search`, which `useBreadcrumbData` feeds straight to
  // URLSearchParams (Record<string, string>).
  validateSearch: (search: Record<string, unknown>): { item?: string; kind?: string; unread?: string; q?: string } => ({
    item: (search.item as string) || undefined,
    kind: (search.kind as string) || undefined,
    unread: search.unread === "1" ? "1" : undefined,
    q: (search.q as string) || undefined,
  }),
});

function InboxComponent() {
  return (
    <InboxUrlProvider>
      <div className="flex h-full min-h-0">
        <InboxList>
          <InboxToolbar>
            <InboxHeader>
              <InboxMarkAllRead />
            </InboxHeader>
            <InboxSearch />
            <InboxKindRail />
            <InboxUnreadToggle />
          </InboxToolbar>
          <InboxRows />
        </InboxList>
        <div className="min-w-0 flex-1">
          <InboxBody />
        </div>
      </div>
    </InboxUrlProvider>
  );
}
